import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["href"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
import { nextTick, onMounted, onUnmounted, ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Tag',
    props: {
        color: { default: 'blue' },
        link: { default: undefined },
        showTooltip: { type: Boolean, default: true },
        className: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const textElementRef = ref();
        const showTooltipCondition = ref(false);
        const checkTextOverflow = () => {
            if (!textElementRef.value)
                return;
            const element = textElementRef.value;
            // scrollWidth가 clientWidth보다 크면 텍스트가 잘린 것
            showTooltipCondition.value = element.scrollWidth > element.clientWidth;
        };
        onMounted(() => {
            // DOM이 완전히 렌더링된 후 체크
            nextTick(() => {
                checkTextOverflow();
            });
            // 창 크기 변경 시에도 다시 체크
            window.addEventListener('resize', checkTextOverflow);
        });
        onUnmounted(() => {
            window.removeEventListener('resize', checkTextOverflow);
        });
        const tag = tv({
            base: clsx('js-tag rounded-2 group relative inline-flex max-w-full items-center px-8 py-4', 'text-caption-2', 'desktop:text-body-6'),
            variants: {
                color: {
                    blue: clsx('bg-blue-150 text-blue-700', 'hover:bg-blue-200'),
                    gray: clsx('bg-gray-150 text-gray-900', 'hover:bg-gray-250'),
                },
            },
        });
        const style = clsx('rounded-4 text-body-6 bg-gray-850 invisible absolute left-1/2 w-max translate-x-[-50%] px-8 py-4 text-white group-hover:visible', 'top-(--tooltip-position) z-[var(--zIndex-tooltip)]', 'after:content-[" "] after:absolute after:border-[6px] after:border-transparent', 'after:border-b-gray-850 after:-top-12 after:left-1/2 after:translate-x-[-50%]');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_unref(tag)({
                    class: props.className,
                    color: props.color,
                }))
            }, [
                (props.link)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        ref_key: "textElementRef",
                        ref: textElementRef,
                        class: "cursor-pointer truncate",
                        href: props.link
                    }, [
                        _renderSlot(_ctx.$slots, "default")
                    ], 8, _hoisted_1))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        ref_key: "textElementRef",
                        ref: textElementRef,
                        class: "truncate"
                    }, [
                        _renderSlot(_ctx.$slots, "default")
                    ], 512)),
                (props.showTooltip && showTooltipCondition.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(_unref(style)),
                        role: "tooltip"
                    }, [
                        _renderSlot(_ctx.$slots, "default")
                    ], 2))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
